import { ROUTES } from 'src/components/app/app-routes.constants';

import { EMPLOYEE_PAGES } from './employee.constants';
// import { AbsenceManagement } from './sub-pages/absence-management';
import { EmployeeInterview } from './sub-pages/employee-interview';
import { EmployeeInterviewDetails } from './sub-pages/employee-interview/components/employee-interview-details';
import { EmployeeDetails } from './sub-pages/employee-details';
import { EmployeeList } from './sub-pages/employee-list';
import { OpenQuestionnairesList } from './sub-pages/open-questionnaires-list';
import { OpenQuestionnairesDetails } from './sub-pages/open-questionnaires-details';

export const getTabPath = (tab: string, id: string) =>
  `${ROUTES.employee}?type=${tab}${id && `&id=${id}`}`;

export const getEmployeePageType = (type: string) => {
  switch (type) {
    case EMPLOYEE_PAGES.appraisalInterviewDetails:
      return EMPLOYEE_PAGES.employeeInterview;
    case EMPLOYEE_PAGES.openQuestionnairesDetails:
      return EMPLOYEE_PAGES.openQuestionnaires;
    default:
      return type;
  }
};

export const getEmployeePage = (type: string) => {
  const isEmployeeProfile =
    type === EMPLOYEE_PAGES.employeeProfile ||
    type === EMPLOYEE_PAGES.employeeInterview ||
    type === EMPLOYEE_PAGES.appraisalInterviewDetails;

  return [
    ...(isEmployeeProfile
      ? [
          {
            tab: 'employeeProfile',
            tabIndex: EMPLOYEE_PAGES.employeeProfile,
            Page: EmployeeDetails,
          },
          {
            tab: 'employeeInterview',
            tabIndex: EMPLOYEE_PAGES.employeeInterview,
            Page:
              type === EMPLOYEE_PAGES.appraisalInterviewDetails
                ? EmployeeInterviewDetails
                : EmployeeInterview,
          },
        ]
      : [
          {
            tab: 'employee',
            tabIndex: EMPLOYEE_PAGES.employee,
            Page: EmployeeList,
          },
          {
            tab: EMPLOYEE_PAGES.openQuestionnaires,
            tabIndex: EMPLOYEE_PAGES.openQuestionnaires,
            Page:
              type === EMPLOYEE_PAGES.openQuestionnairesDetails
                ? OpenQuestionnairesDetails
                : OpenQuestionnairesList,
          },
          // {
          //   tab: 'absenceManagement',
          //   tabIndex: EMPLOYEE_PAGES.absenceManagement,
          //   Page: AbsenceManagement,
          // },
        ]),
  ];
};
